import { studyDataActionNames } from "./actions";

const initialState = {
  studyTime: 82,
  lastActiveTime: Date.now(),
};

export const studyDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case studyDataActionNames.SET_STUDY_TIME: {
      return { ...state, studyTime: action.payload };
    }
    default:
      return state;
  }
};
